import { formatRelative } from "date-fns";
import { ptBR } from "date-fns/locale";
import { InvitationButtons } from "./InvitationButtons";

export function InvitationBox({ invitation, onSubmit }) {
	return (
		<div className="invitation-box">
			<div>
				<div className="invitation-infos">
					<b>{invitation.createdBy ? invitation.createdBy.name : 'Desconhecido'} </b>
					enviou um convite para você participar da
					<b> {invitation.organization.name} </b>
					{invitation.unit.name !== invitation.organization.name && (
						<>
							em
							<b> {invitation.unit.name}</b>
						</>
					)}
				</div>
				<small>Expira {formatRelative(new Date(invitation.expireAt), new Date(), { locale: ptBR })}</small>
			</div>
			<InvitationButtons invitation={invitation} invitationId={invitation.id} onSubmit={onSubmit} />
		</div >
	);
}